<template>
  <div>
    <listing-loader
      v-if="userData"
      page="your_listings"
    />
    <template v-else>
      <p>
        Already a member? Log in below. If you are not a member yet, please
        <router-link :to="{ name: 'registration' }">
          sign up
        </router-link> first.
      </p>

      <login-form />
    </template>
  </div>
</template>

<script>
import LoginForm from '@/components/LoginForm.vue';
import ListingLoader from '@/components/ListingLoader.vue';

export default {
  components: {
    ListingLoader,
    LoginForm,
  },
};
</script>
